// src/features/dashboard/services/Manager/reasonBreakdown.service.ts

import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  ReasonBreakdownRequest,
  ReasonBreakdownResponse,
} from '../../types/Manager/atRiskAssociates.types';

// ======================================
// Get Risk Reason Breakdown
// ======================================

export const getAtRiskReasonBreakdown = async (
  request: ReasonBreakdownRequest
): Promise<ReasonBreakdownResponse[]> => {

  const payload: ReasonBreakdownRequest = {
    managerEmployeeCode: request.managerEmployeeCode,
    fromDate: request.fromDate,
    toDate: request.toDate,
    productivityThreshold: request.productivityThreshold,
    noOfDays: request.noOfDays,
    idleThreshold: request.idleThreshold,
    activeHoursThreshold: request.activeHoursThreshold,
    nonProdThreshold: request.nonProdThreshold,
    attendanceThreshold: request.attendanceThreshold,
  };

  console.log('==============================');
  console.log('Reason Breakdown Request');
  console.log(payload);
  console.log('==============================');

  try {
    const { data } = await api.post<ReasonBreakdownResponse[]>(
      ENDPOINTS.RISK_REASON_BREAKDOWN,
      payload
    );

    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      console.warn(
        'Reason Breakdown API returned 404. Returning empty array.'
      );

      return [];
    }

    console.error('Reason Breakdown API Error:', error);
    throw error;
  }
};